import React from 'react';

const Gallery = () => {
  return (
    <>
      
      <div className="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Gallery page</h1>
          </div>
        </div>
      </div>
      <div className="overflow-hidden space">
        <div className="container">
          <div className="row gy-4">
            <div className="col-md-4 filter-item cat3">
              <div className="gallery-card style2">
                <div className="box-img global-img">
                  <a href="mahakumbhabhisheka.html" className="simple-btn">
                    <i className="fad fa-gallery-thumbnails"></i>
                  </a>
                  <img src="assets/img/photo_gallery/mahakumbhabhisheka/mahakumbhabhisheka.jpg" alt="gallery image" />
                </div>
                <h4 style={{ textAlign: 'center', marginTop: '10px', fontSize: '16px' }}>
                  Maha Kumbhabhisheka - 15th APR 2022
                </h4>
              </div>
            </div>

            <div className="col-md-4 filter-item cat3">
              <div className="gallery-card style2">
                <div className="box-img global-img">
                  <a href="AgastyaKararchithaSriLakshminarasimha.html" className="simple-btn">
                    <i className="fad fa-gallery-thumbnails"></i>
                  </a>
                  <img src="assets/img/photo_gallery/narasimha/narasimha.jpg" alt="gallery image" />
                </div>
                <h4 style={{ textAlign: 'center', marginTop: '10px', fontSize: '16px' }}>
                  Agastya Kararchitha Sri Lakshminarasimha
                </h4>
              </div>
            </div>

            <div className="col-md-4 filter-item cat2 cat3 cat4">
              <div className="gallery-card style2">
                <div className="box-img global-img">
                  <a href="#" className="simple-btn">
                    <i className="fad fa-gallery-thumbnails"></i>
                  </a>
                  <img src="assets/img/photo_gallery/sharada-parameshwari/sharada-parameshwari.jpg" alt="gallery image" />
                </div>
                <h4 style={{ textAlign: 'center', marginTop: '10px', fontSize: '16px' }}>
                  Sri Sharada Parameshwari
                </h4>
              </div>
            </div>

            <div className="col-md-4 filter-item cat2 cat4">
              <div className="gallery-card style2">
                <div className="box-img global-img">
                  <a href="#" className="simple-btn">
                    <i className="fad fa-gallery-thumbnails"></i>
                  </a>
                  <img src="assets/img/photo_gallery/temple-view/temple-view.jpg" alt="gallery image" />
                </div>
                <h4 style={{ textAlign: 'center', marginTop: '10px', fontSize: '16px' }}>
                  Holy Temple View
                </h4>
              </div>
            </div>

            <div className="col-md-4 filter-item cat2 cat4">
              <div className="gallery-card style2">
                <div className="box-img global-img">
                  <a href="#" className="simple-btn">
                    <i className="fad fa-gallery-thumbnails"></i>
                  </a>
                  <img src="assets/img/photo_gallery/bhaktanjaneya/bhaktanjaneya.jpg" alt="gallery image" />
                </div>
                <h4 style={{ textAlign: 'center', marginTop: '10px', fontSize: '16px' }}>
                  Sri Istasiddhi Bhakthanjaneya Swamy Prathistapana Mahostava
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default Gallery;
